export default {
  flash (context, opts) {
    context.commit('SET_VISIBLE', true)
    context.commit('SET_TIMEOUT', (opts.timeout) ? opts.timeout : 0)
    context.commit('SET_MESSAGES', opts.messages)
    context.commit('SET_KIND', opts.kind)
    context.commit('SET_ICON', opts.icon)
  },
  cookie_consent (context, opts) {
    context.commit('SET_COOKIE_VISIBLE', true)
    context.commit('SET_COOKIE_MESSAGES', opts.messages)
    context.commit('SET_COOKIE_KIND', 'cookie')
    context.commit('SET_COOKIE_TIMEOUT', '')
    context.commit('SET_COOKIE_ICON', opts.icon)
  }

}
